/*
 * Javascript for the login and register pages
*/
(function($) {
	if($('body.login,body.register,body.change-password').length) {

		$(document).on('click', '.type-of-membership button', function(e) {
			//$('.type-of-membership button').removeClass('active');
			//$(this).addClass('active');
			$('#register').removeClass('hidden');
			if($(this).hasClass('individual')) {
				$('.mem-type').html('Individual');
				$('#membershipType').val('individual');
				//$(this).addClass('active');
				//$('#register').removeClass('hidden');
			} else if($(this).hasClass('church')) {
				$('.mem-type').html('Church');
				$('#membershipType').val('church');
			} else if($(this).hasClass('organisation')) {
				$('.mem-type').html('Organisation');
				$('#membershipType').val('organisation');
			}
		});

		
		/*$(".tab-content form").validate({
			rules: {
				"membershipNum": {
					required: true,
					number: true,
					minlength: 6,
					maxlength: 6
				},
				"email": {
					required: true,
					email: true
				},
				"newPassword": "required",
				"confirmPassword": {
					equalTo: "#newPassword"
				}
			},
			messages: {
				email: {
					required: "Please enter your email address",
					email: "Please enter a valid email address"
				},
				password: "Please enter your password",
				membershipNum: {
					required: "Please enter your membership number",
					minlength: "Your membership number should be 6 digits",
					maxlength: "Your membership number should be 6 digits",
					number: "Your membership number must only consist of numbers"
				},
				newPassword: "Please enter a password",
				confirmPassword: "Passwords must match"
			}
		});*/

		$(document).on('submit','form',function(e) {
			showLoadingBar();
			$('.form-btn').addClass('spinner');
		});
	}

	window.Parsley.addValidator("equals", {
		requirementType: "string",
		validateString: function(value, element) {
			return value == $(element).val();
		}
	});
	window.Parsley.addValidator("notequalto", {
		requirementType: "string",
		validateString: function(value, element) {
			return value !== $(element).val();
		}
	});
})(jQuery);
